/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import { useState } from 'react';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

import AddMemberDialog from './AddMemberDialog';
import InvitationsTable from './InvitationsTable';
import MembersTable from './MembersTable';

import { useUserContext } from '@/pages/Root';

export default function MembersSettings() {
    const [value, setValue] = useState('members');
    const { isAdmin } = useUserContext().user;

    return (
        <div className="flex flex-col mt-10">
            <div className="flex flex-row justify-between items-center space-x-4">
                <p className="text-sm w-3/4">
                    This will either send an invitation to the user or add them as a member if he already exists in the
                    system and is not already a member of an organisation. If you are adding a member, they will be able
                    to access the organisation immediately. If you are sending an invitation, they will need to accept
                    the invitation before they can access the organisation.
                </p>
                <div className="flex flex-row space-x-4 w-auto">
                    <Select value={value} onValueChange={setValue}>
                        <SelectTrigger className="w-[120px]">
                            <SelectValue />
                        </SelectTrigger>
                        <SelectContent className="max-h-[200px] sm:max-h-[600px]">
                            <SelectItem value="members">Members</SelectItem>
                            <SelectItem value="invitations">Invitations</SelectItem>
                        </SelectContent>
                    </Select>
                    {isAdmin && (
                        <AddMemberDialog
                            onInvite={() => {
                                if (value === 'members') {
                                    setValue('invitations');
                                }
                            }}
                        />
                    )}
                </div>
            </div>
            {value === 'members' && <MembersTable />}
            {value === 'invitations' && <InvitationsTable />}
        </div>
    );
}
